<template>
  <section>

    <div>
      <el-form :inline="true">
        <el-form-item label="物资名称">
          <el-input v-model="filters.key" placeholder="物资名称"></el-input>
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-input v-model="filters.whName" placeholder="仓库名称"></el-input>
        </el-form-item>
        <el-form-item label="是否原材料">
          <el-select v-model="filters.isYCL" placeholder="请选择状态">
            <el-option label="所有" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getMatStock(1)">
            查询
          </el-button>

        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="MatStock" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      style="width: 100%" height="600" :border="true">
      <el-table-column prop="MatName" label="物资名称"></el-table-column>
      <el-table-column prop="WarehouseName" label="仓库名称"></el-table-column>
      <el-table-column prop="Quantity" label="库存量"></el-table-column>
      <el-table-column prop="Price" label="单价"></el-table-column>
      <el-table-column prop="Amount" label="金额"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="300"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatDate" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canDelete" type="danger" @click="() => {
            sels.push(scope.row);
            handleDel();
          }
            ">
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入MatStock.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/matstock";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: {
    Toolbar,
    //  TableDataDialog
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        key: "",
        whName: "",
        page: 1,
        intPageSize: 20,
        isYCL: -1,
      },
      MatStock: [],
      total: 0,


      listLoading: false,
      sels: [], //列表选中列
    };
  },
  computed: {
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getMatStock();
    },
    //获取施工部位列表
    getMatStock(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      api.getMatStockListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.MatStock = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteMatStock(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getMatStock();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.page = 1;
      this.filters.intPageSize = size;
      this.getMatStock();
    },
    // dialogCallback(data) {
    //   console.log(data);
    // },
    // queryData(params) {
    //   return api.getMatStockListPage(params);
    // },
  },
  mounted() {
    this.getMatStock();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
